import { render, staticRenderFns } from "./bakatpilLiten.vue?vue&type=template&id=0ccc95dc&scoped=true"
import script from "./bakatpilLiten.vue?vue&type=script&lang=js"
export * from "./bakatpilLiten.vue?vue&type=script&lang=js"
import style0 from "./bakatpilLiten.vue?vue&type=style&index=0&id=0ccc95dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc95dc",
  null
  
)

export default component.exports